import { motion } from "framer-motion";

export const EASE = [0.16, 1, 0.3, 1];

export const LoadLine = ({ children, delay = 0, className = "", inner = "" }) => (
    <span className={`block overflow-hidden ${className}`}>
        <motion.span
            className={`block will-change-transform ${inner}`}
            initial={{ y: "115%" }}
            animate={{ y: 0 }}
            transition={{ duration: 1.1, delay, ease: EASE }}
        >
            {children}
        </motion.span>
    </span>
);

export const Reveal = ({ children, delay = 0, y = 28, className = "" }) => (
    <motion.div
        className={className}
        initial={{ opacity: 0, y }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.15, margin: "-60px" }}
        transition={{ duration: 0.8, delay, ease: EASE }}
    >
        {children}
    </motion.div>
);

export const Eyebrow = ({ children }) => (
    <p className="flex items-center gap-3 font-mono text-[10px] uppercase tracking-[0.3em] text-brand md:text-[11px]">
        <span className="h-2 w-2 rotate-45 bg-brand" />
        {children}
    </p>
);
